<script lang="ts">
    import WishlistItem from './WishlistItem.svelte';
    import wishlist from '../../store/wishlist';
    import lang from '../../lang/language';
    import { onMount } from 'svelte';

    export let hide: any;

    onMount(() => wishlist.init());
</script>

<div class="boxer thin-scrollbar">
    {#if $wishlist.length > 0}
        {#each $wishlist as item}
            <WishlistItem
                wishlist={item}
                remove={() => wishlist.remove(item)}
            />
        {/each}
    {:else}
        <div class="row text-center" style="padding-top: 50%">
            <i style="font-size: 40px;color: grey" class="far fa-sad-tear" />
            <h3 style="color:grey;margin-left: 10px">{lang.wishlist_empty}</h3>
        </div>
    {/if}
</div>

<div class="row text-center align-items-center justify-content-around w-100">
    {#if $wishlist.length > 0}
        <button
            class="first-button inline-block mb-sm-0 mb-3"
            on:click={wishlist.goToCABS}
        >
            <i class="fas fa-check" />
            {lang.check_availability}
        </button>
    {/if}
    {#if hide}
        <button class="second-button inline-block" on:click={hide}>
            <i class="fas fa-times" />
            {lang.close}
        </button>
    {/if}
</div>

<style>
    .wishlist-arrow {
        width: 0;
        content: '';
        height: 0;
        border-style: solid;
        border-width: 20px 15px 0;
        border-color: #66676b transparent transparent;
        /*top: 100%;*/
        /*right: 50px;*/
        transform: translatey(54px) translateX(255px);
        /*position: absolute;*/
        border-radius: 0;
        z-index: 1;
        border-color: #a8a3a3 transparent transparent;
        transition: all ease-in 0.3s;
    }

    .boxer {
        overflow-y: auto;
        overflow-x: hidden;
        height: 70vh;
        min-height: 370px;
        margin: 0px 4px;
    }

    @media screen and (max-width: 700px) {
        .boxer {
            min-height: unset;
            height: 83%;
        }
    }

    .thin-button {
        padding: 8px 17px;
    }
</style>
